(function(w, $) {
    if (typeof $.fancybox === 'object' && $.fancybox !== null) {
        if (w.globalSettings.language === 3) {
            $.fancybox.defaults.i18n['no'] = {
                CLOSE: 'Lukk',
                NEXT: 'Neste',
                PREV: 'Siste',
                ERROR: 'Det forespurte innholdet kan ikke lastes. <br/>Vennligst prøv igjen senere.',
                PLAY_START: 'Start bildefremvisning',
                PLAY_STOP: 'Pause bildefremvisning',
                FULL_SCREEN: 'Fullskjerm',
                THUMBS: 'Miniatyrbilder',
                DOWNLOAD: 'Last ned',
                SHARE: 'Del',
                ZOOM: 'Zoom'
            };

            $.fancybox.defaults.lang = 'no';
        }

        // Initialize fancybox for old controls
        $().fancybox({
            selector: "a[rel^='lightbox'], a[rel^='fancybox']",
            loop: true,
            buttons: [
                'slideShow',
                'close'
            ],
            caption: function() {
                var $elem = $(this);
                var caption = ($elem.data('caption') ||
                    $elem.attr('data-fancybox-description') ||
                    $elem.attr('fancyboxtext') ||
                    $elem.attr('title') ||
                    $elem.attr('alt') ||
                    '').trim();
                return caption;
            }
        });
    }
})(window, jQuery);